module.exports = (__parcel__import__("gEtyM")).then(() => parcelRequire('fyWP3'));